import { post }  from '@/axios/method';

/**
 * 提交登记表单
 * 毛军锐 http://yapi.dev.anoah.com/project/1225/interface/api/57798
 * @param {*} data 
 * @returns 
 */
export const sendPhoneVerifyCode = (data) => post('/api/dm/market/change-machine/submitRegisterForm', data);